import { yupResolver } from '@hookform/resolvers/yup';
import Close from '@mui/icons-material/Close';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import { useChangeEmailMutation } from '@/api/user/userApiSlice';
import { useParams } from 'react-router-dom';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import AppTextField from '@/common/components/form-inputs/AppTextField';
import { use } from 'i18next';
interface Props {
	email: string;
}

const ChangeEmailModal = ({ email }: Props) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [changeEmail] = useChangeEmailMutation();
	const { id } = useParams();

	const defaultValues: DefaultValues<any> = {
		email: email,
	};

	const formSchema = Yup.object().shape({
		email: Yup.string().nullable().email(t('errorMessage.email')),
	});

	const methods = useForm<any>({
		defaultValues,
		resolver: yupResolver(formSchema),
	});

	useEffect(() => {
		methods.setValue('email', email);
	}, [email]);

	const handleClose = () => {
		methods.reset(defaultValues);
		setOpen(false);
	};

	const onSubmit: SubmitHandler<any> = async (data) => {
		const response = await changeEmail({ ...data, userId: id });
		if ('data' in response) {
			enqueueSnackbar(t('snackbar.changeEmailSuccess'), {
				variant: 'success',
				anchorOrigin: { horizontal: 'center', vertical: 'top' },
				autoHideDuration: 3000,
				action: (key) => {
					return <CloseIcon onClick={() => closeSnackbar(key)} />;
				},
			});
			handleClose();
		}
	};

	return (
		<>
			<IconButton
				color='primary'
				onClick={() => {
					setOpen(true);
				}}
			>
				<CreateOutlinedIcon />
			</IconButton>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='xs'
				fullWidth
				onKeyDown={(e) => {
					if (e.key === 'Tab') {
						e.stopPropagation();
					}
				}}
			>
				<DialogTitle variant='h5'>{t('user.changeEmail')}</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={handleClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<Close />
				</IconButton>
				<DialogContent>
					<FormProvider {...methods}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<Grid container spacing={2} marginTop={0} marginBottom={2}>
								<Grid item xs={12}>
									<AppTextField
										control={methods.control}
										name='email'
										label={t('user.email')}
									/>
								</Grid>
							</Grid>
						</form>
					</FormProvider>
				</DialogContent>
				<DialogActions>
					<Button
						type='submit'
						variant='contained'
						onClick={methods.handleSubmit(onSubmit)}
					>
						{t('button.save')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ChangeEmailModal;
